import React, { useCallback, useEffect,useState } from 'react';
import { ACCOUNT_ICON } from "assets/constants/Icons";
import moment from 'moment';
import ShowToast from 'components/ShowToast';
import { TYPE_SUCCESS, TYPE_FAIL, INTERVAL } from "assets/constants/Constants";
import { createPricingCall, updatePricingCall } from "lib/axiosUtils";
import Select from 'react-select';

const CreatePricingModel = (props) => {
    const [selectedRegion, setSelectedRegion] = useState((props.location.state ? { label: props.location.state.regionId, value: props.location.state.regionId } : null));
    const [selectedModule, setSelectedModule] = useState(props.location.state ? props.location.state.module : "");
    const [selectedCredits, setSelectedCredits] = useState(props.location.state ? props.location.state.creditsRequired : "");
    const [pricingId] = useState(props.location.state ? props.location.state.pricingId : null);
    const [error, setError] = useState({});
    const [regionListComponent, setRegionListComponent] = useState([]);

    const getMetadata = async () => {
        const storedMetadata = localStorage.getItem("metadata");
        if (storedMetadata) {
          console.log("metadata from localStorage::", storedMetadata);
          return JSON.parse(storedMetadata);
        } else {
          console.warn("No metadata found in localStorage");
          return null;
        }
    };

    const renderOptionsRegion = useCallback((optionArray) => {
        if (!optionArray || !Array.isArray(optionArray)) return [];
      
        const options = optionArray.map((item) => ({
          label: item.region,
          value: item.region_id,
        }));
      
        const matchedRegion = options.find(opt => opt.value === selectedRegion?.value);
        if (matchedRegion && selectedRegion?.label !== matchedRegion.label) {
          setSelectedRegion(matchedRegion);
        }
        return options;
    },[selectedRegion]);

    useEffect(() => {
        const fetchData = async () => {
          try {
            const metadata = await getMetadata();    
            let regionOption = [];
            if (metadata && metadata[0]?.meta_data) {
              regionOption = renderOptionsRegion(metadata[0].meta_data.regions);
            }

            setRegionListComponent(regionOption);
    
          } catch (error) {
            console.error("Error fetching data:", error);
          } finally {
          }
        };
    
        fetchData();
    }, [renderOptionsRegion]);

    const userRegionChangeHandler = (event) => {
        // setInputRegion(event.value);
        setSelectedRegion({ label: event.label, value: event.value });
    };
   
    const changeModule = (event) => {
        setSelectedModule(event.target.value);
    }

    const changeCredits = (event) => {
        const regularExpression = /^[0-9\b]+$/;
        if (event.target.value === '' || regularExpression.test(event.target.value)) {
            setSelectedCredits(event.target.value);
        }
    }

    const validatePricingModel = () => {
        const validateFlag = validate();
        if (validateFlag) {
            createPricingModel();
        }
        else {
            ShowToast('Please enter required data', TYPE_FAIL, INTERVAL, null, "");
        }
    }

    const validate = () => {
        let isValid = true;
        let error = {};
       
        if (!selectedRegion) {
            isValid = false;
            error.selectedRegion = "Please select Region";
        }
        if (!selectedModule) {
            isValid = false;
            error.selectedModule = "Please Enter Module Name";
        }
        if (!selectedCredits) {
            isValid = false;
            error.selectedCredits = "Please Enter Credits required";
        }
        setError(error);
        return isValid;
    }

    const cancelHandler = () => {
        window.location.href = "/pricing-model";
      }

    const createPricingModel = async () => {
        const pricingParams = {
            pricingRegion: selectedRegion.value,
            pricingModule: selectedModule,
            pricingCredits: selectedCredits          
        };

        try {
            if (pricingId) {
                await updatePricingCall({}, pricingParams, pricingId);
            }
            else {
                await createPricingCall({}, pricingParams);
            }
            
            ShowToast(`Pricing Model ${pricingId ? "Updated" : "Created"} successfully`, TYPE_SUCCESS, INTERVAL, props, "/pricing-model");
        }
        catch (error) {
            console.log(`Error occurred while ${pricingId ? "updating" : "creating"} Princing Model`, error);
        }
    }

    return (
        <div className="main-content">
            <div className="pagetitle row" style={{ color: 'black', paddingTop: 15 }}>
                <div className="col-md-10 sm_device"><i className={`${ACCOUNT_ICON}`}></i> Pricing Model Creation</div>
                <div className="col-md-2 sm_device" style={{ textAlign: 'right' }}><i className={``}></i> {moment().format("DD MMM YYYY")}</div>
            </div>
            <div className="add-user-wrapper">
                <div className="mx-auto text-left border create-user-div">
                    <div className="user-icon-wrapper"></div>
                    <div style={{ padding: "0 50px", marginBottom: "20px", paddingTop: ".25rem" }} >
                        <div className="row mt-0">
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Region Name</label><span className="text-danger"> *</span>
                                <div className="form-wrap-inner">
                                    <Select
                                        placeholder="Select User Region"
                                        value={selectedRegion}
                                        onChange={userRegionChangeHandler}
                                        options={regionListComponent}
                                        isSearchable
                                    />
                                </div>
                                <div className="text-danger error-msg">
                                    {error.selectedSubscription}
                                </div>
                            </div>
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Module <span className="text-danger">*</span></label>
                                <div className="form-wrap-inner">
                                    <input
                                        className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                        placeholder={`Enter Module Name`}
                                        value={selectedModule}
                                        onChange={changeModule}
                                    />
                                </div>
                                <div className="text-danger error-msg">
                                    {error.selectedModule}
                                </div>
                            </div>
                        </div>
                        <div className="row mt-0">
                            <div className="input-label-group col-md-6">
                            <label className="form-label-outside" htmlFor="general-information-skills">Credits Required</label><span className="text-danger"> *</span>
                                <input
                                    className="form-control brand-font p-3 placeholderColor add-user-input add-user-input-height"
                                    placeholder={`Enter Credits`}
                                    value={selectedCredits}
                                    onChange={changeCredits}
                                />
                                <div className="text-danger error-msg">
                                    {error.selectedCredits}
                                </div>
                            </div>
                        </div>
                        <div className="row mt-0 mt-4 mb-5 display-inline">
                            <div className="form-button-div">
                                <button className="brand-button ml-5" onClick={validatePricingModel}>{pricingId ? "Update" : "Create"} </button>                               
                                 <button className="cancel_button ml-5" onClick={cancelHandler}>Cancel</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row dummy_row"></div>
        </div>
    )
}

export default CreatePricingModel;